export enum ELegalOptions {
	LEGAL_MENTIONS = "mentions-legales",
	CGU = "cgu",
	CGS = "cgs",
	POLITIQUE_DE_CONFIDENTIALITE = "politique-de-confidentialite",
	POLITIQUE_DE_GESTION_DES_COOKIES = "politique-de-gestion-des-cookies",
}
